interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  text?: string | React.ReactNode;
  title?: string;
  internalContainerClass?: string;
  containerClass?: string;
  iconClass?: string;
  ctaButton?: React.ReactNode;
}

const EmptyContainer = ({
  iconClass,
  title,
  icon,
  text,
  internalContainerClass,
  containerClass,
  ctaButton,
}: IProps) => {
  return (
    <div className={`${containerClass} flex w-full justify-center gap-3 rounded-md bg-neutral-50`}>
      <div className={`inline-flex items-center ${internalContainerClass}`}>
        {icon && <div className={`mr-3 p-3 ${iconClass}`}>{icon}</div>}
        {title && <p className="text-base font-medium text-neutral-900">{title}</p>}
        {typeof text === 'string' ? <span className="text-sm font-normal text-neutral-500">{text}</span> : text}
        {ctaButton}
      </div>
    </div>
  );
};

export default EmptyContainer;
